import resources from './translations'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n.use(LanguageDetector).init({
  resources,
  fallbackLng: 'es',
  ns: ['translations'],
  defaultNS: 'translations',
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    formatSeparator: ','
  },
  react: {
    useSuspense: true
  },
  supportedLngs: Object.keys(resources) ?? ['es']
})

export default i18n
export { resources }
